
// export const servername: string = "http://localhost:3000";
export const servername: string = "https://prliveapis.bigblue.in";
// export const servername: string = "https://reachapis.bigblue.in";

// export  const servername: string = "http://localhost:3000";
//export const servername: string = "https://prdevapis.bigblue.in";
// export const servername: string = "https://reachapis.bigblue.in";